'use client';
import React from 'react';

const vendorNotes = [
{
  category: 'COSMOLOGY',
  title: 'The Inception of Space',
  description: 'Space is not a container that things exist within. It is a dynamic fabric that stretches, warps, and participates in the universe\'s story.',
  image: "https://images.unsplash.com/photo-1683523473731-38e28189e8cf",
  alt: 'Vast expanse of deep space showing star clusters, nebulae, and the cosmic web structure of the universe'
},
{
  category: 'BIOLOGY',
  title: 'The Inception of Life',
  description: 'Life began not with a bang but with a chemical whisper — a self-replicating molecule in a warm, mineral-rich pool 3.8 billion years ago.',
  image: "https://images.unsplash.com/photo-1726098869495-ce93dab6dadf",
  alt: 'Microscopic view of single-celled organisms and early life forms in a primordial soup environment'
},
{
  category: 'CIVILIZATION',
  title: 'The Inception of Society',
  description: 'The moment humans began cooperating beyond kinship groups, something unprecedented emerged: civilization, culture, and collective memory.',
  image: "https://images.unsplash.com/photo-1572569152140-9d88e8fca8ee",
  alt: 'Ancient city ruins with stone columns and archaeological remains showing early human urban civilization'
},
{
  category: 'PHYSICS',
  title: 'The Inception of Energy',
  description: 'Energy cannot be created or destroyed — but it had to begin somewhere. The first moments after the Big Bang were pure, undifferentiated energy.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cc11ff8f-1766911697078.png",
  alt: 'Abstract visualization of energy fields and particle collisions in a high-energy physics experiment'
},
{
  category: 'CONSCIOUSNESS',
  title: 'The Inception of Thought',
  description: 'When did the universe first become aware of itself? Consciousness may be the cosmos\'s way of knowing its own existence.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_172585273-1781723195873.png",
  alt: 'Abstract neural network visualization representing consciousness and the emergence of self-aware thought'
},
{
  category: 'TECHNOLOGY',
  title: 'The Inception of Tools',
  description: 'The first stone tool, crafted 3.3 million years ago, was not just a rock. It was the beginning of humanity\'s mastery over matter.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17608072c-1781815451813.png",
  alt: 'Ancient stone tools and flint artifacts showing early human technological development and craftsmanship'
}];


export default function TopicsSection() {
  return (
    <section id="topics" className="bg-[#070a14] py-10 border-b border-[#1e2a3a]">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16">
        <div className="flex items-center justify-between mb-6">
          <h2
            className="text-white font-semibold"
            style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '25.6px', fontWeight: 500 }}>
            
            Explore by Topic
          </h2>
          <a
            href="#topics"
            className="text-[#e01a2e] text-sm font-semibold hover:text-white transition-colors duration-200 flex items-center gap-1"
            style={{ fontFamily: 'Roboto, sans-serif' }}>
            
            Show All
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {vendorNotes.map((item, i) =>
          <TopicCard key={i} item={item} />
          )}
        </div>
      </div>
    </section>);

}

function TopicCard({ item }: {item: typeof vendorNotes[0];}) {
  return (
    <figure className="group cursor-pointer bg-[#0d1120] border border-[#1e2a3a] hover:border-[#e01a2e] rounded-sm overflow-hidden transition-all duration-300 hover:shadow-[0_4px_20px_rgba(224,26,46,0.12)]">
      <div className="relative overflow-hidden" style={{ aspectRatio: '16/9' }}>
        <img
          src={item.image}
          alt={item.alt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d1120] via-[#0d1120]/40 to-transparent" />
      </div>
      <figcaption className="p-4">
        <span
          className="block text-[10px] font-bold tracking-widest text-[#e01a2e] uppercase mb-2"
          style={{ fontFamily: 'Roboto, sans-serif' }}>
          
          {item.category}
        </span>
        <h3
          className="text-white font-bold text-[15px] leading-snug mb-2 group-hover:text-[#e01a2e] transition-colors duration-200"
          style={{ fontFamily: 'Montserrat, sans-serif' }}>
          
          {item.title}
        </h3>
        <p
          className="text-[#a0aec0] text-[13px] leading-relaxed line-clamp-3"
          style={{ fontFamily: 'Roboto, sans-serif' }}>
          
          {item.description}
        </p>
      </figcaption>
    </figure>);

}